import { render, staticRenderFns } from "./InputAssetGroup.vue?vue&type=template&id=ec501f62&scoped=true&"
import script from "./InputAssetGroup.vue?vue&type=script&lang=ts&"
export * from "./InputAssetGroup.vue?vue&type=script&lang=ts&"
import style0 from "./InputAssetGroup.vue?vue&type=style&index=0&id=ec501f62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec501f62",
  null
  
)

export default component.exports